module.exports = __webpack_public_path__ + "static/media/card-blog12.f70533fb.jpg";